import React from 'react';
import Box from '@mui/material/Box';
import { node, string, func, bool } from 'prop-types';

const FormWrapper = ({
	action = '',
	children,
	disableWrapperStyle = false,
	id,
	method,
	onSubmit,
}) => {
	const styleProps = {
		pt: 8,
		pb: 4,
		px: 4,
		m: { xs: '1rem', sm: '0 auto' },
		maxWidth: { xs: '100%', sm: '464px' },
	};

	return (
		<Box
			// Add optional action attribute to form, so the default action will be preserved
			// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#form-submission-attributes
			action={action}
			component="form"
			id={id}
			// A "name" attribute is required for the element to have its implicit role of "form"
			name="identityFormWrapper"
			onSubmit={onSubmit}
			{...(!disableWrapperStyle && styleProps)}
			{...(method && { method })}
		>
			{children}
		</Box>
	);
};

FormWrapper.propTypes = {
	action: string,
	children: node.isRequired,
	disableWrapperStyle: bool,
	id: string,
	method: string,
	onSubmit: func.isRequired,
};

export default FormWrapper;
